import _ from "lodash";
import ko from "knockout";
import log from "services/loggingService";

/**
 * <p>Binding handler for injecting an include binding into a localized string.</p>
 * <p>
 *   Example:<br/>
 *   <pre class="prettyprint">
 * &lt;div data-bind="lTemplate: {name: 'messageKey.withTemplateKey', data: $data}"&gt;
 *  &lt;!-- templates are rendered here --&gt;
 * &lt;/div&gt;
 *   </pre>
 *   <br/>
 *   The message key's token requires to have 3 brackets around it: {{{templateToken}}}
 *   <br/>
 *   Where $data is: <br/>
 *   <pre class="prettyprint">
 * &lt;div {tokenName: 'templates/myTemplate', tokenName2: {name: 'templates/myOtherTemplate', data: 'viewModelName'}
 * &lt;/div&gt;
 *   </pre>
 *   A token's value can either be a path to a template, or an object the contains the "name" of a template, and a "data" attributed that MUST be a string that refers to
 * </p>
 * @exports bindingHandlers/lTemplate
 */
ko.bindingHandlers.lTemplate = {
    update: function (element, valueAccessor) {
        const bindingData = ko.utils.unwrapObservable(valueAccessor());
        const name = ko.unwrap(bindingData.name);
        const templateInfos = bindingData.data;
        const locale = bindingData.locale;

        const data = {};
        _.forIn(templateInfos, function (value, key) {
            const templateString = value.name || value;

            let templateDiv =
                '<div class="ltemplate-editor" data-bind="template: \'' +
                templateString +
                "'\"></div>";

            if (value.data) {
                const templateData = ko.unwrap(value.data);

                if (typeof templateData !== "string") {
                    log.error(
                        "The value for the data attribute of the token '" +
                            key +
                            "' MUST be a string or an observable whose value is a string."
                    );
                }

                templateDiv =
                    '<div class="ltemplate-editor" data-bind="template: { name: \'' +
                    templateString +
                    "', " +
                    "data: " +
                    templateData +
                    '}"></div>';
            }

            // // The template data's key needs to match the token in the string resource, and
            // // it also needs to match the name of the view model property in the binding context.
            // var templateDiv = '<div class="ltemplate-editor" data-bind="template: { name: ' + "'" + value + "', " +
            //                                                                       "data: " + key + '}"></div>';
            data[key] = templateDiv;
        });

        element.innerHTML = ko.i18n.renderString(name, data, locale);
    },
};

export default ko.bindingHandlers.lTemplate;
